export const localSave = (key, value) => {
	localStorage.setItem(key, JSON.stringify(value))
}

export const localRead = (key) => {
	return JSON.parse(localStorage.getItem(key)) || ''
}
